module.exports = "precision highp float;\nvarying vec3 fragColor;\n\nvoid main() {\n  gl_FragColor = vec4(fragColor, 1);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/main.frag
// module id = 481
// module chunks = 0